import React, { useEffect, useState } from 'react';
import Forms from '../../composant/FormsSliders/Forms';
import NavMenuAdmin from '../../composant/navMenu/NavMenuAdmin';
import Sidebar from '../../composant/Sidebar/Sidebar';
import { useDropzone } from 'react-dropzone';

export default function Index(props) {
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] },
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
    }
  });

  const thumbs = files.map(file => (
    <div key={file.name} className="inline-flex border border-gray-300 rounded m-2 w-24 h-24 p-1 box-border">
      <div className="flex min-w-0 overflow-hidden">
        <img
          src={file.preview}
          className="block w-auto h-full"
          onLoad={() => { URL.revokeObjectURL(file.preview) }}
        />
      </div>
    </div>
  ));

  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  const ContainerUpload = (
    <div className="p-4 border border-dashed border-gray-400 rounded text-center">
      <div {...getRootProps({ className: 'cursor-pointer' })} className="bg-white py-6 px-4 rounded-lg border border-gray-300 hover:border-gray-500 transition duration-200">
        <input {...getInputProps()} />
        <p className="text-sm text-gray-500">Solte arquivos aqui para enviar, ou clique para selecionar</p>
      </div>
      <div className="flex flex-wrap mt-4">
        {thumbs}
      </div>
    </div>
  );

  return (
    <>
      <Sidebar />
      <NavMenuAdmin />
      <div className="p-6">
        <Forms images={files} upload={ContainerUpload} />
      </div>
    </>
  );
}
